<template>

    <FloatingPanel title="Nieuws">

        <div class="canvas::blocks-modules-news-BlockPanel">

            <Tabs :tabs="[
                'Nieuws',
                'Algemeen',
            ]">

                <div slot="Nieuws">

                    <!-- Category Accordion (only shown if categories are enabled) -->
                    <accordion-input v-if="categoriesEnabled" :open="true">
                        <template #label>
                            <div class="font-medium text-gray-600">Categorieën</div>
                        </template>
                        <template #content>
                            <div class="mb-1 text-sm text-gray-600">Selecteer categorieën om te filteren</div>

                            <select
                                v-model="options.categories"
                                multiple
                                class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                                style="min-height: 120px;"
                            >
                                <option v-for="category in categories" :key="category.id" :value="category.id">
                                    {{ category.name }}
                                </option>
                            </select>
                        </template>
                    </accordion-input>

                    <!-- Pagination Accordion -->
                    <accordion-input :open="true">
                        <template #label>
                            <div class="font-medium text-gray-600">Paginatie</div>
                        </template>
                        <template #content>
                            <div class="mb-4">
                                <div class="mb-1 text-sm text-gray-600">Aantal items per pagina</div>

                                <input
                                    type="number"
                                    class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                                    placeholder="10"
                                    v-model="options.pagination"/>
                            </div>

                            <SwitchInput
                                label="Toon paginatie"
                                instruction=""
                                :options="options"
                                options-property="showPagination"
                                :items="[
                                    { value: true, label: 'Aan'},
                                    { value: false, label: 'Uit'},
                                ]"
                                :defaultValue="true"
                                :accordion="false"
                                :spacing="{'horizontal': false, 'vertical': true}"
                            />
                        </template>
                    </accordion-input>

                    <SwitchInput
                        label="Mobiele slider"
                        instruction="Toon items als slider op mobiel"
                        :options="options"
                        options-property="showMobileSlider"
                        :items="[
                            { value: 1, label: 'Aan'},
                            { value: 0, label: 'Uit'},
                        ]"
                        :defaultValue="1"
                    />

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"/>

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        AccordionInput,
        SwitchInput,
    },

    data() {
        return {
            categoriesEnabled: false,
            categories: [],
        };
    },

    mounted() {
        this.fetchNewsCategories();

        // Initialize options if not set
        if (!this.options.categories) {
            this.$set(this.options, 'categories', []);
        }
        if (this.options.showPagination === undefined) {
            this.$set(this.options, 'showPagination', true);
        }
    },

    methods: {
        async fetchNewsCategories() {
            try {
                const response = await fetch('/api/news-categories');
                const data = await response.json();

                this.categoriesEnabled = data.enabled;
                this.categories = data.categories;
            } catch (error) {
                console.error('Failed to fetch news categories:', error);
            }
        },
    },

}

</script>
